import React, { FC, useEffect, useState, useRef } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
// import QRCode from "react-qr-code";
import operatorApi from "api/operator/operator.api";
import menuApi from "api/menu/menu.api";
import Loading from "components/Loading/Loading";
import { FaDownload, FaPrint } from "react-icons/fa";
import axios from "axios";
import { baseSocketURL, baseURL, socketId } from "configs/axiosConfig";

import { QRCode } from "react-qrcode-logo";
import {
  ChevronDownIcon,
  ClockIcon,
  MapIcon,
  MapPinIcon,
  MinusCircleIcon,
  PlusCircleIcon,
  PrinterIcon,
  QrCodeIcon,
} from "@heroicons/react/24/outline";
import { MdOutlineArrowCircleDown } from "react-icons/md";

import { setIsCartOpen, setContactInfo } from "../../redux/features/cartState";
import MenuItem from "./menuItem/MenuItem";

import FloatingCartButton from "./menuItem/FloatingCartButon";
import CartMenu from "containers/CartPage/CartMenu";
import { useDispatch, useSelector } from "react-redux";
import LocationModal from "./menuItem/Location";
import AboutUsModal from "./menuItem/AboutUs";
import CartModal from "./menuItem/CartModal";
import { RootState } from "redux/store";
import MenuList from "./MenuList";
import MenuListWithSidebar from "./MenuListWithSidebar";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";
import CancelAllOrdersModal from "components/CancelAllOrdersModal";
import { toast } from "react-toastify";

export interface MenuItem {
  id: string;
  title: string;
  price: number;
  desc: string;
  category: string;
  operator: string;
}

export interface MenuProps {
  className?: string;
}

interface Operator {
  _id: string;
  name?: string;
  email?: string;
  password?: string;
  isAdmin?: boolean;
  coverPhoto?: string;
  photo?: string;
  phone?: string;
  address?: string;
  bio?: string;
  quote?: string;
  createdAt?: string; //
  slug?: string;
}

interface MenuCategory {
  _id: string;
  name: string;
  image: string;
  operator: string;
}

const Menu: FC<MenuProps> = ({ className = "" }) => {
  const { slug } = useParams<{ slug: string }>(); // ✅ use

  console.log({ slug });

  const [operator, setOperator] = useState<Operator[]>([]);
  const [menuCategories, setMenuCategories] = useState<MenuCategory[]>([]);
  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const qrRef = useRef<HTMLDivElement>(null);

  const [modalItem, setModalItem] = useState<MenuItem | null>(null); // NEW STATE

  const [showCancelModal, setShowCancelModal] = useState(false);

  const user = useSelector((state: RootState) => state.auth.user);
  useEffect(() => {
    if (!user) {
      dispatch(setAuthModalOpen(true));
    }
  }, [user, dispatch]);

  const [onlineUsers, setOnlineUsers] = useState<
    { userId: string; socketId: string }[]
  >([]);

  useEffect(() => {
    const userId = user?._id;
    if (userId) {
      socketId.emit("addUser", userId);
      socketId.on("getUsers", (data: any) => {
        // console.log("getUsers", data);
        setOnlineUsers(data);
      });
    }
  }, [user]);

  // console.log({ onlineUsers });

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setIsLoading(true);
  //     await Promise.all([getOperator(), getMenuCategories(), getMenuItems()]);
  //     setIsLoading(false);
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    if (!slug) return;

    let cancelled = false;

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const operatorId = await getOperator(); // wait for _id first
        if (!operatorId || cancelled) return;

        await Promise.all([
          getMenuCategories(operatorId),
          getMenuItems(operatorId),
        ]);
      } catch (e) {
        console.error(e);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  const getOperator = async (): Promise<string | null> => {
    try {
      const data = await operatorApi.getOperatorBySlug(slug!);
      const operatorData = Array.isArray(data) ? data : [data];
      setOperator(operatorData);

      const id = operatorData[0]?._id ?? null;
      if (!id) toast.error("Operator not found for this slug.");
      return id;
    } catch (error) {
      const msg = error instanceof Error ? error.message : "Unknown error";
      toast.error(`Error fetching operator by slug: ${msg}`);
      return null;
    }
    // NOTE: don't set isLoading here; the outer effect controls it
  };

  console.log({ operator });
  const id = operator[0]?._id;

  const getMenuCategories = async (operatorId: string) => {
    try {
      const response = await menuApi.getMenuCategory({ operator: operatorId });
      if (response?.success && response?.category) {
        setMenuCategories(response.category);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const getMenuItems = async (operatorId: string) => {
    try {
      const response = await menuApi.getMenuItems({ operator: operatorId });
      if (response?.success) {
        const items = Array.isArray(response.menuItems)
          ? response.menuItems
          : response.menuItems
          ? [response.menuItems]
          : [];
        setMenuItems(items);
      } else {
        console.warn("Unexpected response structure:", response?.data);
      }
    } catch (error) {
      console.error("Error fetching menu items:", error);
    }
  };

  const downloadQRCode = () => {
    const canvas = document.getElementById("QR") as HTMLCanvasElement;
    if (canvas) {
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      let downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `${operator[0].name}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const [expandedAboutus, setExpandedAboutus] = useState(false);

  const handleAboutUsExpandClick = () => {
    setExpandedAboutus(!expandedAboutus);
  };

  const [expandedSeeInMap, setExpandedSeeInMap] = useState(false);

  const handleSeeInMapExpandClick = () => {
    setExpandedSeeInMap(!expandedSeeInMap);
  };

  const downloadCodeMobile = () => {
    const canvas = document.getElementById("QR-mobile") as HTMLCanvasElement;
    if (canvas) {
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      let downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `${operator[0].name}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  const printQRCode = () => {
    window.print();
  };

  // expansion menu
  const [expandedCategory, setExpandedCategory] = useState<string | null>(null);

  // Ensure the first category opens by default once menuCategories are available
  useEffect(() => {
    if (menuCategories.length > 0) {
      setExpandedCategory(menuCategories[0]._id);
    }
  }, [menuCategories]);

  const toggleCategory = (categoryId: any) => {
    setExpandedCategory(expandedCategory === categoryId ? null : categoryId);
  };

  const isOperatorOnline = onlineUsers.some(
    (user) => user.userId === operator[0]?._id
  );

  const [selectedCategoryId, setSelectedCategoryId] = useState(
    menuCategories[0]?._id
  );
  const businessInfo = {
    name: "Colon Care Centre",
    rating: "4.9",
    reviewCount: "1,010",
    openUntil: "6:00 pm",
    address: "639 New North Road, Morningside, Auckland",
    directionsLink: "https://www.google.com/maps",
  };

  const [selectedValues, setSelectedValues] = useState<any[]>([]); // or a proper type

  const toggleSelection = (item: any) => {
    setSelectedValues((prev) => {
      const exists = prev.find((v) => v._id === item._id);
      if (exists) {
        return prev.filter((v) => v._id !== item._id);
      } else {
        return [...prev, { _id: item._id, title: item.title, desc: item.desc }];
      }
    });
  };

  if (isLoading) {
    return <Loading />;
  }

  if (!user) {
    return <Loading />; // or <Loading /> if you want a spinner until they sign in
  }

  return (
    <div className="h-full w-full ">
      {/* Cover image */}
      <div className="desktop w-full max-w-[1280px] mx-auto">
        <img
          src={operator[0].coverPhoto}
          alt="Operator"
          className="rounded h-[200px] w-full object-cover"
        />
      </div>
      {/* Top section  */}
      <div className="max-w-[1280px] mx-auto flex flex-col md:flex-row p-5">
        {/* Left Section (30%) */}
        <div className="flex flex-col items-center justify-center w-full md:w-[30%] mt-5 cursor-pointer xs:flex-fow">
          <div
            // onClick={() => navigate(`/author/${operator[0]._id}`) }

            onClick={() => setShowCancelModal(true)}
          >
            <div className="relative">
              <img
                src={operator[0].photo}
                alt="Operator"
                className="rounded-full border-[2px] border-neutral-200 dark:border-neutral-500 p-2 object-cover w-[200px] h-[200px] sm:w-[200px] sm:h-[200px]"
              />
              {/* Green Dot positioned next to the avatar */}
              {/* <span
                className={`absolute bottom-[10px] right-[30px] w-5 h-5 border-2 border-white rounded-full ${
                  isOperatorOnline ? "bg-green-500" : "bg-gray-400"
                }`}
              /> */}

              <p className="text-sm text-center mt-2 font-semibold">
                {isOperatorOnline ? "🟢 Online" : "🔴 Offline"}
              </p>
            </div>
          </div>
        </div>

        {/* / Right Section (70%)   */}
        <div className="w-full lg:w-[70%] p-0 gap-4 border-0 desktop ">
          <div className="flex flex-row items-center gap-2 justify-end ">
            <div className="desktop w-full">
              <h3 className="text-2xl font-bold text-black capitalize pt-0 sm:pt-3 text-center dark:text-red-500">
                {operator[0].name}
              </h3>
              <p className="text-sm text-black capitalise text-center  dark:text-neutral-200">
                {operator[0].address}
              </p>
              <div className="w-[50%] m-auto mt-2">
                <div className="flex">
                  <button
                    className="flex items-center space-x-2 border p-2 rounded w-[100%] justify-center dark:border-neutral-500"
                    onClick={handleSeeInMapExpandClick}
                  >
                    <MapPinIcon className="text-red-300 text-[10px] max-h-[20px]" />
                    <span className="text-gray-800 text-sm dark:text-neutral-200">
                      See On Map
                    </span>
                  </button>
                  <button
                    className="flex items-center space-x-2 border p-2 rounded w-[100%] justify-center dark:border-neutral-500"
                    onClick={handleAboutUsExpandClick}
                  >
                    <ClockIcon className="text-red-300 text-[10px] max-h-[20px]" />
                    <span className="text-gray-800 text-sm dark:text-neutral-200">
                      About us
                    </span>
                  </button>
                </div>
                <div className="flex">
                  <button
                    className="flex items-center space-x-2 border p-2 rounded w-[100%] justify-center dark:border-neutral-500"
                    onClick={handleExpandClick}
                  >
                    <QrCodeIcon className="text-red-300 text-[10px] max-h-[20px]" />
                    <span className="text-gray-800 text-sm dark:text-neutral-200">
                      QR Download
                    </span>
                  </button>
                  <button
                    className="flex items-center space-x-2 border p-2 rounded w-[100%] justify-center dark:border-neutral-500"
                    onClick={printQRCode}
                  >
                    <PrinterIcon className="text-red-300 text-[10px] max-h-[20px]" />
                    <span className="text-gray-800 text-sm dark:text-neutral-200">
                      Print
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div ref={qrRef} className="self-end ">
              <QRCode
                value={window.location.href}
                logoImage={operator[0].photo}
                logoHeight={50}
                logoWidth={50}
                logoOpacity={1}
                enableCORS={true}
                qrStyle="dots"
                eyeRadius={10}
                id={"QR"}
                size={220}
              />
            </div>
          </div>
        </div>

        {/* Mobile display  */}
        <div className=" mobile w-full sm:w-[70%] p-4 gap-4  gap-2 flex flex-col items-center justify-center">
          <h3 className="text-2xl font-bold text-black capitalize pt-0 sm:pt-3 text-center dark:text-red-500">
            {operator[0].name}
          </h3>
          <p className="text-sm text-black capitalize pt-0 sm:pt-3 text-center dark:text-neutral-200">
            {operator[0].address}
          </p>
          <div className="w-[80%] m-auto mt-5">
            <button
              className="flex items-center space-x-2 border p-2 rounded w-[100%] justify-center dark:border-neutral-500"
              onClick={handleSeeInMapExpandClick}
            >
              <MapPinIcon className="text-red-300 text-[10px] max-h-[20px]" />
              <span className="text-gray-800 text-sm  dark:text-neutral-200">
                See On Map
              </span>
            </button>
            <button
              className="flex items-center space-x-2 border p-2 rounded w-[100%] justify-center dark:border-neutral-500"
              onClick={handleAboutUsExpandClick}
            >
              <ClockIcon className="text-red-300 text-[10px] max-h-[20px]" />
              <span className="text-gray-800 text-sm dark:text-neutral-200">
                About us
              </span>
            </button>
            <button
              className="flex items-center space-x-2 border p-2 rounded w-[100%] justify-center dark:border-neutral-500"
              onClick={handleExpandClick}
            >
              <QrCodeIcon className="text-red-300 text-[10px] max-h-[20px]" />
              <span className="text-gray-800 text-sm  dark:text-neutral-200">
                QR Download
              </span>
            </button>
          </div>
        </div>
        {/* Modal Component */}
        <div
          className={`fixed inset-0 flex items-center justify-center z-50 ${
            expanded ? "block" : "hidden"
          }`}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
        >
          <div
            className="absolute inset-0 bg-black opacity-50"
            onClick={handleExpandClick}
          ></div>

          <div className="relative p-6 bg-white rounded-lg shadow-lg max-w-md mx-auto">
            {/* Avatar section */}
            <div className="flex items-center justify-center mt-[-5rem] ">
              <div className="relative">
                <div className="absolute right-0 bottom-0 w-6 h-6 rounded-full bg-green-500 z-10"></div>
                <img
                  src={operator[0].photo}
                  alt="operator avatar"
                  className="w-24 h-24 border-2 border-black object-cover rounded-full backdrop-blur-sm"
                />
              </div>
            </div>

            {/* Name Section */}
            <div className="flex flex-col items-center mt-5">
              <p className="text-xl font-bold uppercase text-center text-black">
                {operator[0].name}
              </p>
            </div>

            {/* QR Code Section */}
            <div className="flex justify-center mt-4">
              <QRCode
                value={window.location.href}
                logoImage={operator[0].photo}
                logoHeight={100}
                logoWidth={100}
                logoOpacity={1}
                enableCORS={true}
                qrStyle="dots"
                eyeRadius={10}
                id="QR-mobile"
                size={300}
              />
            </div>

            {/* Download Button */}
            <button
              type="button"
              onClick={downloadCodeMobile}
              className="mt-4 flex flex-col items-center justify-center bg-gray-300 text-black rounded-sm w-[150px] hover:bg-gray-600 hover:shadow-none"
            >
              QR Download
            </button>
          </div>
        </div>
        {/* Cancel Modal Component About Us*/}

        <CancelAllOrdersModal
          isOpen={showCancelModal}
          onClose={() => setShowCancelModal(false)}
          operatorId={operator[0]?.slug}
        />

        {/* Modal Component About Us*/}
        <AboutUsModal
          expandedAboutus={expandedAboutus}
          handleAboutUsExpandClick={handleAboutUsExpandClick}
          operator={operator}
        />
        {/* Modal component See in Map */}
        <LocationModal
          operator={operator}
          expanded={expandedSeeInMap}
          handleExpandClick={handleSeeInMapExpandClick}
        />
      </div>

      {/* Bottom section */}
      {/* Original Menu */}
      {/* <MenuList
        menuCategories={menuCategories}
        menuItems={menuItems}
        expandedCategory={expandedCategory}
        toggleCategory={toggleCategory}
        setModalItem={setModalItem}
      /> */}
      {/* New Style Menu follow fresha */}
      <MenuListWithSidebar
        menuCategories={menuCategories}
        menuItems={menuItems}
        selectedCategoryId={selectedCategoryId}
        setSelectedCategoryId={setSelectedCategoryId}
        setModalItem={setModalItem}
        businessInfo={businessInfo}
        expandedCategory={undefined} // <-- quick patch
      />

      {modalItem && (
        <CartModal item={modalItem} onClose={() => setModalItem(null)} />
      )}

      {/* Floating cart button  */}
      <FloatingCartButton />
    </div>
  );
};

export default Menu;
